import { extendObservable, action } from 'mobx';

import ReportApi from '../psuite-js/apis/delivery/report';

class ReportStore {

    constructor() {
        extendObservable(this, {
            vehicles: {},

            timeout_to_sync: null,
            time_to_sync: 6000,

            fetching: false,
            fetch_cancel_source: null,

            is_fetched: false,

            fetched: { active: false, pending: false, done: false },

            last_fetch_length: 0,

            fetch: action(this.fetch.bind(this)),

            updated_at: new Date(),
        });
    }

    async fetch(params = {}, quiet = false) {
        if (this.fetch_cancel_source) {
            this.fetch_cancel_source.cancel();
        }

        this.fetching = !quiet;

        const response = await ReportApi.all(params);

        if (response.status === 200) {
            const vehicles = response.data.data || [];

            this.vehicles = vehicles;
            this.updated_at = new Date();
        }

        this.is_fetched = true;
        this.fetching = false;
        this.fetch_cancel_source = null;

        return response;
    }
}

export default new ReportStore();



// WEBPACK FOOTER //
// ./src/stores/report.js